import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ORDER_HISTORY, { HTTPS_URL } from '../../../organisms/AccountPage/Constants/Constants';

export const OrderDeliveryDistaIFrame = ({ orderDetails = {} }) => {
  const { TRACK_ORDER } = ORDER_HISTORY;

  const getTrackingURL = () => {
    const trackingURL = orderDetails?.deliveryPartner?.tracking_url;
    return (trackingURL && trackingURL.indexOf(HTTPS_URL) === -1 ? HTTPS_URL : '') + trackingURL;
  };
  return (
    <iframe
      sandbox='allow-same-origin allow-scripts'
      title={translateWithI18Next(TRACK_ORDER)}
      src={getTrackingURL()}
    ></iframe>
  );
};
